// The user's last language in this browser while on a building with translations on - the
// `preferredLocale` step of resolveLanguage (src/i18n/locale-resolution.ts). Per user, so a shared
// browser doesn't hand one account's language to another. The account's user.locale wins when the
// building offers it; this matters when it doesn't, or user.locale is null: for an Administrator
// (PUT /admin can't save it yet) and for anyone who hasn't picked a language, so moving between two translated buildings keeps the
// language instead of jumping to each building's default. Set by a Profile picker pick, or seeded
// by UserLocaleSync with the first language the user gets on a translated building.
//
// Best effort: storage can be unavailable (private mode, blocked site data) - then the user just
// falls back to the building default.

const storageKey = (userId: number | string) => `EL-preferred-language-${userId}`

export const readPreferredLanguage = (userId: number | string | undefined): string | null => {
  if (userId === undefined || userId === null) return null
  try {
    return window.localStorage.getItem(storageKey(userId))
  } catch {
    return null
  }
}

export const writePreferredLanguage = (userId: number | string | undefined, language: string) => {
  if (userId === undefined || userId === null) return
  try {
    window.localStorage.setItem(storageKey(userId), language)
  } catch {
    // see above
  }
}
